import { createAnalyticsGroup } from 'js/lib/analytics'

const track = createAnalyticsGroup('Listing Breadcrumbs Clicks')

//GA analytics
$('.js-c-listing-breadcrumb').on('click', '.js-c-listing-breadcrumb__crumb', event => {
  const level = event.target.dataset.level
  track('click', level)
})
